import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Any path the router has no page for. The server answers it with a 404 and noindex (meu-treino-api src/seo/)
export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-root mt-root--page mt-auth-page">
      <div className="mt-auth-card">
        <div className="mt-auth-card__done">
          <h1 className="mt-auth-card__title">{t('pages.NotFound.title')}</h1>
          <p className="mt-auth-card__text">{t('pages.NotFound.text')}</p>
          <Link to="/" className="mt-btn mt-btn--primary mt-auth-card__submit">
            {t('pages.NotFound.home')}
          </Link>
        </div>
      </div>
    </div>
  );
};
